import { IAddUpdateFilaEsperaRequest } from "../../../../model/admin-portal/request/add-update-fila-espera-request";
import { IFilaEsperaResponse } from "../../../../model/admin-portal/response/fila-espera-response";
import { ITipoFilaEsperaResponse } from "../../../../model/admin-portal/response/tipo-fila-espera-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type FilasEsperaState = {
    dataPaginatedListResponse: PaginationResponse<IFilaEsperaResponse>;
    isLoadingData: boolean;
    dataResponse: IFilaEsperaResponse | null;
    dataRequest: IAddUpdateFilaEsperaRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    tiposList: ITipoFilaEsperaResponse[];
};

export const initialDataRequest: IAddUpdateFilaEsperaRequest = {
    id: null,
    idTipoFilaEspera: null,
    nomeUnidade: '',
    quantidadeAguardando: null,
    quantidadeVagasTotais: null,
    quantidadeMatriculados: null,
    textoCriteriosPriorizacao: '',
    dtaAtualizacao: ''
};

export const initialState: FilasEsperaState = {
    dataPaginatedListResponse: new PaginationResponse<IFilaEsperaResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    tiposList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setTiposList = 'setTiposList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IFilaEsperaResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IFilaEsperaResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateFilaEsperaRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setTiposList; payload: ITipoFilaEsperaResponse[] };

export const filasEsperaReducer = (state: FilasEsperaState, action: Action): FilasEsperaState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setTiposList:
            return { ...state, tiposList: action.payload };
        default:
            return state;
    }
};
